import React, { PureComponent } from "react";
import GroupPartnerLogo from "../components/GroupPartnerLogo";
import FooterBar from "../components/FooterBar";
import FooterMenu from "../components/FooterMenu";
import SocialLink from "../components/SocialLink";
import LanguageSwitcher from "../components/LanguageSwitcher";

class Footer extends PureComponent {
  render() {
    return (
      <div className="footer">
        <div className="group-partner-logo-block">
          <div className="container">
            <GroupPartnerLogo />
          </div>
        </div>
        <div className="footer-menu-block">
          <div className="container">
            <FooterMenu />
          </div>
        </div>
        <div className="social-block">
          <div className="container">
            <div className="row">
              <div className="col-7">
                <SocialLink />
              </div>
              <div className="col-5 change-language">
                <LanguageSwitcher />
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bar-block">
          <FooterBar />
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js